import { notification } from "@shared/antd/notification";
import { ArgsProps } from "antd/lib/notification";
import { ErrorIcon, InfoIcon, SuccessIcon } from "../../../resources/icons/add-icons";
import React from "react";
import { isMobileCheck } from "../util";

const mobileWidth = { width: "16px", height: "16px" };
const descWidth = { width: "24px", height: "24px" };

export default new (class {
  error = (arg: ArgsProps) => {
    notification.open({ ...arg, className: "error-notification" });
  };

  info = (arg: ArgsProps) => {
    notification.info({ ...arg, className: "info-notification" });
  };

  success = (arg: ArgsProps) => {
    notification.open({ ...arg, className: "success-notification" });
  };

  successMobile = (arg: ArgsProps) => {
    const IS_MOBILE = isMobileCheck();

    notification.open({
      ...arg,
      placement: "topRight",
      className: `notification-custom success ${
        IS_MOBILE ? "mobile" : "desktop"
      }`,
      icon: IS_MOBILE ? (
        <SuccessIcon style={mobileWidth} />
      ) : (
        <SuccessIcon style={descWidth} />
      ),
    });
  };

  errorMobile = (arg: ArgsProps) => {
    const IS_MOBILE = isMobileCheck();

    notification.open({
      ...arg,
      placement: "topRight",
      className: `notification-custom error ${
        IS_MOBILE ? "mobile" : "desktop"
      }`,
      icon: IS_MOBILE ? (
        <ErrorIcon style={mobileWidth} />
      ) : (
        <ErrorIcon style={descWidth} />
      ),
    });
  };

  infoMobile = (arg: ArgsProps) => {
    const IS_MOBILE = isMobileCheck();

    notification.open({
      ...arg,
      placement: "topRight",
      className: `notification-custom info ${IS_MOBILE ? "mobile" : "desktop"}`,
      icon: IS_MOBILE ? (
        <InfoIcon style={mobileWidth} />
      ) : (
        <InfoIcon style={descWidth} />
      ),
    });
  };
})();
